import {Reducers} from './dataEnum';

// Device Info
export const UPDATE_DEVICE_INFO = `${Reducers.DEVICE_INFO_STORE}/UPDATE_DEVICE_INFO`;
export const DEVICE_SERIAL_NUMBER = `${Reducers.DEVICE_INFO_STORE}/DEVICE_SERIAL_NUMBER`;
export const FIRMWARE_NAME = `${Reducers.DEVICE_INFO_STORE}/FIRMWARE_NAME`;
export const FIRMWARE_VERSION = `${Reducers.DEVICE_INFO_STORE}/FIRMWARE_VERSION`;
export const SOFTWARE_NAME = `${Reducers.DEVICE_INFO_STORE}/SOFTWARE_NAME`;
export const SOFTWARE_VERSION = `${Reducers.DEVICE_INFO_STORE}/SOFTWARE_VERSION`;
export const BUILD_DATE = `${Reducers.DEVICE_INFO_STORE}/BUILD_DATE`;
export const HOST_NAME = `${Reducers.DEVICE_INFO_STORE}/HOST_NAME`;
export const IP_ADDRESS = `${Reducers.DEVICE_INFO_STORE}/IP_ADDRESS`;

export const SET_DEVICE_PROPERTIES = `${Reducers.DEVICE_INFO_STORE}/SET_DEVICE_PROPERTIES`;
export const SET_DEVICE_PROPERTY_NAME = `${Reducers.DEVICE_INFO_STORE}/SET_DEVICE_PROPERTY_NAME`;
export const RESET_DEVICE_PROPERTIES = `${Reducers.DEVICE_INFO_STORE}/RESET_DEVICE_PROPERTIES`;
export const SET_DEVICE_NAME = `${Reducers.DEVICE_INFO_STORE}/SET_DEVICE_NAME`;
export const SET_HARDWARE_PROPERTIES = `${Reducers.DEVICE_INFO_STORE}/SET_HARDWARE_PROPERTIES`;
export const SET_AUTO_TIMEZONE = `${Reducers.DEVICE_INFO_STORE}/SET_AUTO_TIMEZONE`;
export const SET_AUTO_DATETIME = `${Reducers.DEVICE_INFO_STORE}/SET_AUTO_DATETIME`;
export const SET_ORIGIN_AUTO_TIMEZONE = `${Reducers.DEVICE_INFO_STORE}/SET_ORIGIN_AUTO_TIMEZONE`;
export const SET_ORIGIN_AUTO_DATETIME = `${Reducers.DEVICE_INFO_STORE}/SET_ORIGIN_AUTO_DATETIME`;
export const SET_TIMEZONE_FROM_SERVER = `${Reducers.DEVICE_INFO_STORE}/SET_TIMEZONE_FROM_SERVER`;
export const SET_DEVICE_DATETIME = `${Reducers.DEVICE_INFO_STORE}/SET_DEVICE_DATETIME`;
// License
export const UPDATE_INITIAL_LICENSE_INFO = `${Reducers.DEVICE_INFO_STORE}/UPDATE_INITIAL_LICENSE_INFO`;
export const UPDATE_LICENSE_INFO = `${Reducers.DEVICE_INFO_STORE}/UPDATE_LICENSE_INFO`;
export const LICENSE_STATUS = `${Reducers.DEVICE_INFO_STORE}/LICENSE_STATUS`;
export const LICENSE_TYPE = `${Reducers.DEVICE_INFO_STORE}/LICENSE_TYPE`;
export const LICENSE_MODIFIED_DATE = `${Reducers.DEVICE_INFO_STORE}/LICENSE_MODIFIED_DATE`;
export const LICENSE_EXPIRED_DATE = `${Reducers.DEVICE_INFO_STORE}/LICENSE_EXPIRED_DATE`;
export const CLIENT_ID = `${Reducers.DEVICE_INFO_STORE}/CLIENT_ID`;
export const LICENSE_ACTIVATION_MODE = `${Reducers.DEVICE_INFO_STORE}/LICENSE_ACTIVATION_MODE`;
export const LICENSE_TRIAL_AVAILABLE = `${Reducers.DEVICE_INFO_STORE}/LICENSE_TRIAL_AVAILABLE`;
export const LICENSE_DAY_LEFT = `${Reducers.DEVICE_INFO_STORE}/LICENSE_DAY_LEFT`;
export const LICENSE_DAY_LEFT_CHECK_DATE = `${Reducers.DEVICE_INFO_STORE}/LICENSE_DAY_LEFT_CHECK_DATE`;
export const LICENSE_DAY_LEFT_ALERT_AVAILABLE = `${Reducers.DEVICE_INFO_STORE}/LICENSE_DAY_LEFT_ALERT_AVAILABLE`;
